import React from 'react';
import { CheckCircle2Icon, ComputerIcon, PrinterIcon, SchoolIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const moments = [{
  icon: ComputerIcon,
  text: 'Abrís la computadora.'
}, {
  icon: CheckCircle2Icon,
  text: 'Elegís la planificación.'
}, {
  icon: PrinterIcon,
  text: 'Imprimís.'
}, {
  icon: SchoolIcon,
  text: 'Entrás al aula tranquila.'
}];
export function WeekFlowSection() {
  return <section className="bg-orange-50 py-10 sm:py-14 md:py-16" data-id="element-251">
      <div className="container mx-auto px-4 md:px-6" data-id="element-252">
        <div className="mx-auto max-w-4xl text-center" data-id="element-253">
          <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-orange-600" data-id="element-254">
            La semana puede sentirse diferente
          </p>
          <h2 className="mt-2 text-3xl font-black leading-tight tracking-tight text-slate-900 sm:text-4xl" data-id="element-255">
            Imaginá empezar la semana así...
          </h2>
          <p className="mx-auto mt-4 max-w-lg text-xl font-black leading-tight text-pink-600 sm:text-2xl" data-id="element-256">
            Todo ya está preparado.
            <br data-id="element-257" />
            No hay estrés.
            <br data-id="element-258" />
            No hay improvisación.
            <br data-id="element-259" />
            Simplemente enseñás.
          </p>
        </div>

        <div className="mx-auto mt-7 grid max-w-4xl gap-2.5 sm:grid-cols-2 sm:gap-3" data-id="element-260">
          {moments.map(({
          icon: Icon,
          text
        }, index) => <motion.div key={text} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.06
        }} className="flex items-center gap-3 rounded-2xl border border-orange-100 bg-white p-4 shadow-sm" data-id="element-261">
              <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-yellow-100 text-orange-600" data-id="element-262">
                <Icon className="h-5 w-5" data-id="element-263" />
              </span>
              <p className="font-extrabold text-slate-900" data-id="element-264">{text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}